<template>
  <div class="media-gallery-navigation">
    <button
      type="button"
      class="media-gallery-navigation__prev"
      @click="prev"
    >
      <slot name="gallery-prev-icon">
        <IconArrow class="icon icon--arrow icon--arrow-prev" />
      </slot>
    </button>

    <button
      type="button"
      class="media-gallery-navigation__next"
      @click="next"
    >
      <slot name="gallery-next-icon">
        <IconArrow class="icon icon--arrow icon--arrow-next" />
      </slot>
    </button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryOptions, galleryItems, activeItem, setItem } = useUiMediaGallery(props.name)

function prev() {
  if (!activeItem.value) {
    return
  }

  let prev = activeItem.value.index - 1

  if (prev < 1) {
    prev = galleryItems.value.length
  }

  setItem(prev, galleryOptions.value.behavior)
}

function next() {
  if (!activeItem.value) {
    return
  }

  let next = activeItem.value.index + 1

  if (next > galleryItems.value.length) {
    next = 1
  }

  setItem(next, galleryOptions.value.behavior)
}
</script>

<style>
@import url("~layers/app/components/Ui/MediaGallery/Navigation.css");
</style>
